module.exports = __webpack_public_path__ + "img/google-logo.f36d72e7.svg";